import { render, staticRenderFns } from "./InputFieldMock.vue?vue&type=template&id=888d1ee0&"
import script from "./InputFieldMock.vue?vue&type=script&lang=ts&"
export * from "./InputFieldMock.vue?vue&type=script&lang=ts&"
import style0 from "./InputFieldMock.vue?vue&type=style&index=0&id=888d1ee0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports